<template>
    <BaseLayout>
        <div class="container py-5">
            <div class="col-lg-5 col-md-7 mx-auto">
                <div class="shadow rounded-4 p-lg-5 p-3">
                    <div class="text-center mb-4">
                        <h1 class="ff-dsb fs-36 text-primary">Sign Up</h1>
                        <p class="fs-20">Create an account to buy, lease, rent or sell cars</p>
                    </div>
                    <form @submit.prevent="submit" class="vstack gap-4" autocomplete="off">
                        <Fields :fields="registerForm" :register="true"/>
                        <!-- <div class="form-check text-start">
                            <input class="form-check-input" :class="errors.agreement ? 'is-invalid':''" type="checkbox" name="agreement" v-model="registerForm.agreement">
                            <label class="form-check-label">
                                I hereby agree to the
                                <Link :href="route('page.show', 'tnc')">Terms & Conditions</Link>
                                and the
                                <Link :href="route('page.show', 'pp')">Privacy Policy</Link>.
                            </label>
                            <div class="invalid-feedback">
                                {{ errors.agreement }}
                            </div>
                        </div> -->
                        <div class="text-center">
                            <button class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" type="submit" :disabled="registerForm.processing">
                                Sign Up <i v-if="registerForm.processing" class="fad fa-spinner-third fa-spin"></i>
                            </button>
                        </div>
                        <div class="text-center">
                            Already have an account?
                            <Link :href="route('user.login')">
                                Log in
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </BaseLayout>
</template>

<script setup>
import { useReCaptcha } from 'vue-recaptcha-v3';
import { useForm, Link } from '@inertiajs/vue3';
import BaseLayout from '../../../../../../resources/js/front/Layouts/BaseLayout.vue';
import Fields from '../Components/Fields.vue';

const props = defineProps({ errors: Object })
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

const registerForm = useForm({
    name: null,
    email: null,
    contact_no: null,
    password: null,
    password_confirmation: null,
    //agreement: null,
    g_recaptcha_response: null,
})

async function submit() {
    await recaptchaLoaded()
    registerForm.g_recaptcha_response = await executeRecaptcha('login')
    registerForm.post(route('user.register'))
}
</script>